export default __webpack_public_path__ + "static/media/longlogo-white.a15cd201.png";